import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchTransaction(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/ledger/list', {
    query: {}
  });
  yield put({
    // $global: true,
    type: 'SET_TRANSACTIONS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* removeTransaction(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.delete, '/ledger/remove', {
    query: {
      transactionNumber: payload.transactionNumber,
    }
  });
  yield put({
    type: 'FETCH_TRANSACTIONS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* createTransaction(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/ledger/create', {
    body: {
      ...payload.data,
    }
  });
  yield put({
    type: 'FETCH_TRANSACTIONS',
  });

  yield put({
    type: 'TOGGLE_MODAL',
    payload: {
      active: false,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst, takeLatest }) {
  yield [
    takeLatest('FETCH_TRANSACTIONS', fetchTransaction),
    takeLatest('REMOVE_TRANSACTION', removeTransaction),
    takeFirst('CREATE_TRANSACTION', createTransaction),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/Ledger.sagas.js